	export enum EarSideEnum {
		Right = 1,
		Left = 2
	}
